import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportSpecialUnitsFilters, getReportSpecialUnitsAction } from "redux/actions/Reports/reportSpecialUnits/reportSpecialUnitsActions";

export const ReportSpecialUnitsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, station, customer } = useSelector(state => state.reportSpecialUnits);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", "warning"); return; }
    if (!customer?.idCustomer) { setSnackbar("Falta seleccionar cliente.", "warning"); return; }
    dispatch(getReportSpecialUnitsAction({ startDate, customer, isPdf }));
  }, [startDate, station, customer, dispatch, setSnackbar]);

  const handleSubmitExcel = useCallback((e) => handleSubmit(e, false), [handleSubmit]);

  return (
    <GlobalBox title="Reporte Unidades Especiales" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportSpecialUnits"
        date
        stations
        customers
        maxDate={newDate()}
        dispatchAction={setReportSpecialUnitsFilters}
        submitAction={handleSubmit}
        submitSecond={handleSubmitExcel}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingReportSpecialUnits}
      />
      {isLoadingComp?.loadingReportSpecialUnits && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
